import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';
import Label from 'components/form/Label/Label';
import React from 'react';
import { parseTradeline } from './PaymentHistoryTradeline.js';
import {
  SixMonthPaymentHistoryTable,
  BureauPillAndRefreshButtonTableComponent,
  TradelineNotification,
  TradelineHeader,
} from '../Components/FactorTradelineBaseComponents.js';
import { isPremium, isFreeTrial, isPlus1B, isFree } from 'helpers/userHelper';
import { getSimplifiedDate } from 'helpers/dateHelper';
import { providerMapping } from 'customHelpersPath/factorMapping.helper';
import { useEventHandler } from 'hook/event.hook.js';
import { useHistory } from 'react-router-dom';
import { canPurchase3BReport } from 'pages_CreditReportTU/creditReportTU3B.helper';

const { ALL, TRANS_UNION, EXPERIAN, EQUIFAX } = BUREAU_ENUMS;

const PaymentHistoryFactorTradeLineComponent = props => {
  const eventHandler = useEventHandler();
  const history = useHistory();
  const {
    tradeline,
    userInfo,
    selectedBureau,
    profileContainer,
    creditReports,
  } = props;
  const creditProfileRefreshDate =
    profileContainer?.modules[0]?.additionalData?.creditProfileRefreshDate;
  const isPremiumUser = isPremium(userInfo) && !isFreeTrial(userInfo);
  const isFreeUser = isFree(userInfo);
  const isDownloadAvailable = canPurchase3BReport({
    userInfo,
    creditReportRes: creditReports,
  });
  const is1B = isPlus1B(userInfo);
  const parsedTradeline = parseTradeline(
    tradeline,
    selectedBureau,
    eventHandler,
    history,
  );
  const transUnionBureauAnnotation = parsedTradeline?.transunion?.annotation;
  const equifaxBureauAnnotation = parsedTradeline?.equifax?.annotation;
  const experianBureauAnnotation = parsedTradeline?.experian?.annotation;
  const refreshDate = new Map([
    [ALL, getSimplifiedDate(new Date())],
    [TRANS_UNION, getSimplifiedDate(new Date())],
    [EQUIFAX, getSimplifiedDate(creditProfileRefreshDate?.equifax)],
    [EXPERIAN, getSimplifiedDate(creditProfileRefreshDate?.experian)],
  ]);
  const titleStyle = () => {
    if (parsedTradeline?.defaultAnnotation?.current) {
      return 'bold';
    } else if (parsedTradeline?.defaultAnnotation?.delinquent) {
      return 'bold fontYellow400';
    } else if (parsedTradeline?.defaultAnnotation?.derogatory) {
      return 'bold fontRed4';
    }
  };
  return (
    <FlexContainer
      className={
        'bgWhite flex-column grayShadow16 margt16 padlr30 padb24 padt30 m-padt18 m-pad10 border-rad8px'
      }
    >
      <TradelineHeader
        titleStyle={titleStyle}
        title={parsedTradeline?.creditor}
        subtitle={parsedTradeline?.grantedTradeAccountType}
        basedOnBureauLabel={
          'Based on ' +
          providerMapping.get(selectedBureau) +
          ' report from ' +
          refreshDate.get(selectedBureau)
        }
        accountAmmount={parsedTradeline?.dueAmount}
        statusLabel={parsedTradeline?.payStatus}
      />
      <FlexContainer className={'flex-column'}>
        <Label type="Lato-Bold" className={'bold margt16 text-10'}>
          6 MONTH PAYMENT HISTORY
        </Label>
        <FlexContainer className={'margtb12 justify-between gap-10'}>
          <SixMonthPaymentHistoryTable
            parsedTradeline={parsedTradeline}
            selectedBureau={selectedBureau}
            isDownloadAvailable={isDownloadAvailable}
            isPremiumUser={isPremiumUser}
          />
          <BureauPillAndRefreshButtonTableComponent
            is1B={is1B}
            transUnionBureauAnnotation={transUnionBureauAnnotation}
            equifaxBureauAnnotation={equifaxBureauAnnotation}
            experianBureauAnnotation={experianBureauAnnotation}
            isDownloadAvailable={isDownloadAvailable}
            isPremiumUser={isPremiumUser}
            selectedBureau={selectedBureau}
            isFreeUser={isFreeUser}
          />
        </FlexContainer>
      </FlexContainer>
      <TradelineNotification parsedTradeline={parsedTradeline} />
    </FlexContainer>
  );
};

export { PaymentHistoryFactorTradeLineComponent };
